const storeKey = '__babafuchsAgbAcceptanceStore';
const stateEventName = 'babafuchs:agb-acceptance-state';

if (!window[storeKey]) {
  let state = { status: 'idle', value: '' };
  let queue = Promise.resolve();
  let requestSequence = 0;
  let initialized = false;

  const publish = (nextState) => {
    state = nextState;
    document.dispatchEvent(new CustomEvent(stateEventName, { detail: state }));
  };

  const write = (value) => {
    const requestId = ++requestSequence;
    publish({ status: 'saving', value });

    const operation = queue
      .catch(() => undefined)
      .then(async () => {
        const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          keepalive: true,
          body: JSON.stringify({ attributes: { agb_acceptance: value } }),
        });

        if (!response.ok) throw new Error('AGB acceptance could not be stored.');
        return response.json();
      });

    queue = operation;

    return operation.then(
      (cart) => {
        if (requestId === requestSequence) {
          publish({ status: value === '' ? 'idle' : 'accepted', value });
        }
        return cart;
      },
      (error) => {
        if (requestId === requestSequence) {
          publish({ status: 'error', value: '' });
        }
        throw error;
      },
    );
  };

  const initialize = () => {
    if (!initialized) {
      initialized = true;
      return write('');
    }

    return queue;
  };

  const clear = () => {
    if (
      initialized &&
      state.value === '' &&
      (state.status === 'idle' || state.status === 'saving')
    ) return queue;

    initialized = true;
    return write('');
  };

  const store = {
    get state() {
      return state;
    },
    write,
    initialize,
    clear,
  };

  window[storeKey] = store;

  document.addEventListener('line-item:will-change', () => {
    void store.clear().catch(() => undefined);
  });

  document.addEventListener('cart:change', () => {
    void store.clear().catch(() => undefined);
  });

  document.addEventListener('cart:refresh', () => {
    void store.clear().catch(() => undefined);
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      void store.clear().catch(() => undefined);
    }
  });
}

const acceptanceStore = window[storeKey];

if (!customElements.get('babafuchs-agb-checkout-gate')) {
  customElements.define(
    'babafuchs-agb-checkout-gate',
    class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();

        this.checkbox = this.querySelector('[data-agb-acceptance]');
        this.checkoutButton = this.querySelector('.babafuchs-agb-checkout-button');
        this.errorMessage = this.querySelector('[data-agb-error]');

        if (!this.checkbox || !this.checkoutButton) return;

        this.checkbox.addEventListener(
          'change',
          () => {
            const value = this.checkbox.checked ? this.dataset.acceptanceValue : '';
            void acceptanceStore.write(value).catch(() => undefined);
          },
          { signal: this.abortController.signal },
        );

        document.addEventListener(
          stateEventName,
          (event) => this.synchronize(event.detail),
          { signal: this.abortController.signal },
        );

        const initialization = acceptanceStore.initialize();
        this.synchronize(acceptanceStore.state);
        void initialization.catch(() => undefined);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      synchronize(state) {
        const pending = state.status === 'saving';
        const accepted =
          state.status === 'accepted' && state.value === this.dataset.acceptanceValue;

        this.checkbox.checked =
          state.value === this.dataset.acceptanceValue && (pending || accepted);
        this.checkbox.disabled = pending;
        this.checkoutButton.disabled = !accepted;
        this.toggleAttribute('aria-busy', pending);

        if (this.errorMessage) {
          this.errorMessage.hidden = state.status !== 'error';
        }
      }
    },
  );
}
